import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class SetMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      submitSuccess: '',
      error: '',
      loading: false,
    };
  }

  handleChange = (event) => {
    this.setState({ message: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { message } = this.state;

    if (!message.trim()) {
      this.setState({ error: "Message cannot be empty" });
      return;
    }

    this.setState({ loading: true });

    try {
      const response = await fetch('/setmessage', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message }),
      });

      const result = await response.json();

      if (response.ok) {
        this.setState({ submitSuccess: 'Message submitted successfully!', error: '', message: '', loading: false });

        // Store token and navigate
        localStorage.setItem('token', result.token);
        this.props.history.push('/showtokens3');
      } else {
        this.setState({ error: result.error || 'Failed to submit the message.', loading: false });
      }
    } catch (err) {
      this.setState({ error: 'An error occurred while submitting the message.', loading: false });
    }

    // Auto-hide messages after 3 seconds
    setTimeout(() => {
      this.setState({ submitSuccess: '', error: '' });
    }, 3000);
  };

  render() {
    const { message, submitSuccess, error, loading } = this.state;

    return (
      <div className="message-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className='logo' src={logo} alt="Logo" />
          <h2>Type Your Message:</h2>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <textarea
                      id="messageTextarea"
                      rows="8"
                      cols="50"
                      className="form-control"
                      value={message}
                      onChange={this.handleChange}
                      placeholder="Type your message here..."
                    />
                    <button type="submit" className="btn btn-primary mt-3" disabled={loading}>
                      {loading ? 'Submitting...' : 'Submit Message'}
                    </button>
                  </form>
                  {submitSuccess && <div className="alert alert-success mt-3">{submitSuccess}</div>}
                  {error && <div className="alert alert-danger mt-3">{error}</div>}
                  <div className="text-center mt-3">
                    <div>Powered by</div>
                    <img className='logo2' src={logo2} alt="Logo 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SetMessage);
